import { createRequestTypes } from '../utils';

export const FETCH_SUBSTANCE_INFORMATIONS = createRequestTypes(
  'substanceInformationFunction/FETCH_SUBSTANCE_INFORMATIONS',
);
export const DELETE_SUBSTANCE_INFORMATION = createRequestTypes(
  'substanceInformationFunction/DELETE_SUBSTANCE_INFORMATION',
);
export const SAVE_SUBSTANCE_INFORMATION = createRequestTypes('substanceInformationFunction/SAVE_SUBSTANCE_INFORMATION');
